import * as React from "react";
import { Navigate } from "react-router-dom";

import useAuth from "../../hooks/useAuth";
import { hasDashboardAccess } from "../../lib/dashboardAccess";
import NoDashboardAccess from "../../pages/auth/NoDashboardAccess";

// For routes that can only be accessed by authenticated users
function AuthGuard({ children }) {
  const { isAuthenticated, isInitialized, method, user } = useAuth();

  if (isInitialized && !isAuthenticated) {
    return <Navigate to="/auth/sign-in" />;
  }

  // Only the cookie path carries grants; the legacy JWT path keeps its
  // email-map access unchanged.
  if (
    method === "cookie" &&
    isAuthenticated &&
    user &&
    !hasDashboardAccess(user)
  ) {
    return <NoDashboardAccess />;
  }

  return <React.Fragment>{children}</React.Fragment>;
}

export default AuthGuard;
